export const LOAD_MY_HUNTS = "app/MyHunts/LOAD_MY_HUNTS";
export const LOAD_MY_HUNTS_FAILURE = "scavr/MyHunts/LOAD_MY_HUNTS_FAILURE";
export const LOAD_MY_HUNTS_SUCCESS = "scavr/MyHunts/LOAD_MY_HUNTS_SUCCESS";
